export const REDIRECT_AFTER_AUTH_PARAM = 'redirectAfterAuth'
